import {AppService} from "@/service/app.service";
import {AxiosService} from "@/service/axios.service";
import {KRBS_CIRCULARS} from "@/config/constants.config";
import axios from "axios";
import {AlertService} from "@/service/alert.service";
import _, {toLower} from "lodash";

const state={
    circulars:[],
    circularsForSelection:[],
    selected_circular:'',

    circularAttachments: [],

    circularSubjects: [],

}

const mutations={
    SET_CIRCULARS:(state,circulars)=>state.circulars=circulars,
    // SET_CIRCULAR_SUBJECTS:(state,circularSubjects)=>state.circularSubjects=circularSubjects,

    SET_CIRCULAR_SUBJECTS(state, circularSubjects) {
        state.circularSubjects = circularSubjects;
    },

    SET_CIRCULAR_ATTACHMENTS(state, circularAttachments){
        state.circularAttachments = circularAttachments
    },

    SET_CIRCULARS_FOR_SELECTION:(state,circularsForSelection)=>state.circularsForSelection=circularsForSelection,
    SET_ADDED_CIRCULAR:(state,circular)=>{
       let index=state.circulars.findIndex(c=>c.id==circular.id);
        if(index < 0){
           state.circulars.unshift(circular)
        }
        else{
            state.circulars.splice(index,1,circular)
        }
    },
    SET_UPDATED_CIRCULAR:(state,circular)=>{
        let index=state.circulars.findIndex((r)=>r.id==circular.id);
        state.circulars.splice(index,1,circular)
    },
    SET_SELECTED_CIRCULAR:(state,circular)=>state.selected_circular=circular,
    DELETE_CIRCULAR:(state,circular)=>{
        let id=isNaN(circular) ? circular.id : circular
        let index=state.circulars.findIndex((r)=>r.id==id);
        if(isNaN(circular)){
            state.circulars.splice(index,1,circular);
        }
        else{
            state.circulars.splice(index,1);
        }

    }
}

const actions={
    async searchCrewAttachment({commit,rootState},params){
        let userType=toLower(rootState.AuthModule.authUser.scope ?? '');
        commit('SET_CIRCULAR_ATTACHMENTS',[]);
        commit('set_is_loading', true);
        let queryString=AppService.generateQueryString(params ?? '');
        return AxiosService.get(`${userType}`+KRBS_CIRCULARS.CIRCULARS.SEARCH_ATTACHMENTS + queryString)
            .then(res=>{
                commit('set_is_loading', false);
                commit('SET_CIRCULAR_ATTACHMENTS',res.data.data.data);
                // console.log(res.data.data.data, 'hello')
                commit('set_circular_attachment_pagination',res.data.data);
            });
    },

    async getCirculars({commit,rootState},params){
        let userType=toLower(rootState.AuthModule.authUser.scope ?? '');
        commit('SET_CIRCULARS',[]);
        let queryString=AppService.generateQueryString(params ?? '');
        return AxiosService.get(`${userType}`+KRBS_CIRCULARS.CIRCULARS.SEARCH + queryString)
            .then(res=>{
                commit('SET_CIRCULARS',res.data.data.data);
                commit('set_crew_pagination',res.data.data);
            });
    },

    async getCircularForSelection({commit,rootState},params) {
        let userType=toLower(rootState.AuthModule.authUser.scope ?? '');
        commit('SET_CIRCULARS_FOR_SELECTION',[]);
        let queryString=AppService.generateQueryString(params ?? '');
        return AxiosService.get(`${userType}`+KRBS_CIRCULARS.CIRCULARS.SEARCH + queryString)
        .then(res=>{
            commit('SET_CIRCULARS_FOR_SELECTION',res.data.data.data);
            commit('set_pagination',res.data.data);
        });
    },

    async deleteCircular({commit},circular){
        return AxiosService.post(KRBS_CIRCULARS.CIRCULARS.DELETE, {id:circular.id}).then((res)=>{
            return true;
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'DELETE CIRCULAR')
            return false;
        });
    },
    async updateCircular({commit},params){
        return AxiosService.post(KRBS_CIRCULARS.CIRCULARS.UPDATE,params).then((res)=>{
            commit('SET_UPDATED_CIRCULAR',res.data.data);
            return res.data.data;
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'UPDATE CIRCULAR')
            return AlertService.parseErrors(e.response.data.errors);
        });
    },

    async addCircular({commit},params){
       return AxiosService.post(KRBS_CIRCULARS.CIRCULARS.ADD,params).then((res)=>{
          commit('SET_ADDED_CIRCULAR',res.data.data);
          return res.data.data;
       }).catch(e=>{
           AlertService.responseAlertMessage(e,'ADD CIRCULAR')
           return AlertService.parseErrors(e.response.data.errors);
       });
    },
    async getCircularFile({commit,rootState},circular){
        let userType=toLower(rootState.AuthModule.authUser.scope ?? '');
        return AxiosService.get(`${userType}/circular/${circular}/file`).then(res=>{
            return res.data.data ? res.data.data : [];
        }).catch(e=>{
            AlertService.responseAlertMessage(e,'VIEW CIRCULAR FILE');
            return AlertService.parseErrors(e.response.data.errors ?? null);
        })
    },

    async getCircularSubjects({commit, rootState}, params) {
        let userType = toLower(rootState.AuthModule.authUser.scope);
        commit('SET_CIRCULAR_SUBJECTS', []);
        await AxiosService.get(userType + KRBS_CIRCULARS.CIRCULARS.GET_CIRCULAR_SUBJECTS, params).then(r => {
            commit('SET_CIRCULAR_SUBJECTS',r.data.data);
        }).catch((e) => {
            AlertService.responseAlertMessage(e, 'GET CIRCULAR SUBJECTS');
            return e;
        });
    },

}

const getters={
    circulars:(state)=>AppService.capitalizeProperties(state.circulars),
    circularSubjects:(state)=>AppService.capitalizeProperties(state.circularSubjects),

    circularAttachments:(state)=>AppService.capitalizeProperties(state.circularAttachments),

    circularsForSelection:(state)=>AppService.capitalizeProperties(state.circularsForSelection),
    selected_circular:(state)=>state.selected_circular,
}

export default {state,getters,mutations,actions}
